module.exports = {
    shortMonths: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'İyun', 'İyul', 'Avq', 'Sen', 'Okt', 'Noy', 'Dek'],
    shortDays: ['Baz', 'B.Er', 'Ç.Ax', 'Çər', 'C.Ax', 'Cüm', 'Şən'],

    /* 01. Common */
    'common.actions.add': 'Əlavə Et',
    'common.actions.confirm': 'Təsdiq Et',
    'common.actions.submit': 'Göndər',
    'common.actions.cancel': 'İmtina',
    'common.actions.loading': 'Yüklənir...',
    'common.actions.update': 'Yenilə',
    'common.actions.orderby': 'Sırala',
    'common.actions.lockScreen': 'Ekranı Kilidlə',
    'common.actions.allDevices': 'Bütün Cihazlar',
    'common.actions.messages': 'İsmarıclar',
    'common.actions.changePassword': 'Şifrəni Dəyiş',
    'common.actions.logout': 'Çıxış Et',
    'common.actions.printCheck': 'Qəbzi Çap Et',
    'common.actions.checkIt': 'Qəbzi Yoxla',
    'common.actions.addTicket': 'Biletə Əlavə Et',

    'common.list': 'Siyahı',
    'common.cashier': 'Kassir',
    'common.confirmDeleteTitle': 'Silmək istədiyinizə əminsinizmi?',
    'common.currentLimit': 'Cari Balans',
    'common.remainingLimit': 'Cari Balans',
    'common.live': 'Canlı',
    'common.goal': 'qol',

    /* ================================================================================================================================= */

    /* 02. Menu */
    'menu.home': 'Ana Səhifə',
    'menu.sports': 'İdman',
    'menu.live': 'Canlı',
    'menu.e-sports': 'Kiberidman',
    'menu.prematch': 'Prematç',
    'menu.results': 'Nəticələr',
    'menu.printProgram': 'Proqramı Çap Et',
    'menu.dailyReport': 'Hesabat',
    'menu.balanceReport': 'Balans Hesabatı',
    'menu.point': 'Digərlər',
    'menu.point.creditLimit': 'Aralıq Ödəniş',
    'menu.actions.playNow': 'İndi Oyna',
    'menu.actions.playLive': 'Canlı Oyna',
    'menu.actions.look': 'Bax',
    'menu.actions.printNow': 'Çap Et',
    'menu.actions.increase': 'Artır',

    /* ================================================================================================================================= */

    /* 03. Input & Selectbox */
    'input.placeholder.voucherAmount': 'Vouçer Məbləği',
    'input.placeholder.scanBarcode': 'Skan Et və ya Barkodu Daxil Et',
    'input.placeholder.eventIdOrEventName': 'Hadisə Kodu və ya Adını Daxil Et',
    'input.placeholder.shortCode': 'Qısa Kod',
    'selectbox.selectMarket': 'Mərc Növü Seç',
    'selectbox.selectOutcome': 'Proqnozu Seç',

    /* ================================================================================================================================= */

    /* 04. Login */
    'login.message.welcomeTo': 'Xoş Gəlmisiniz!',
    'login.message.userPanel': 'Kassir İstifadəçi İnterfeysi',
    'login.message.sport': 'İdman',
    'login.message.sportMean': 'insanları həm fiziki, həm də mənəvi yüksəldən vasitədir',
    'login.input.username': 'İstifadəçi Adı',
    'login.input.password': 'Şifrə',
    'login.input.show': 'Göstər',
    'login.input.hide': 'Gizlət',
    'login.actions.login': 'Daxil Ol',
    'login.actions.loading': 'Yüklənir...',

    /* ================================================================================================================================= */

    /* 05. Filter & Sort */
    'filter.allCountries': 'Bütün Ölkələr',
    'filter.allCategories': 'Bütün Kateqoriyalar',
    'filter.allLeagues': 'Bütün Liqalar',
    'filter.allTimes': 'Bütün Vaxt',
    'sort.byLeague': 'Liqaya Görə Düz',
    'sort.byTime': 'Vaxta Görə Düz',
    'sort.byDescending': 'Azalan Sırada',
    'sort.byAscending': 'Artan Sırada',

    /* ================================================================================================================================= */

    /* 06. Title */
    'title.sports': 'İdman',
    'title.prematch': 'Prematç',
    'title.messages': 'İsmarıclar',
    'title.point': 'Digərlər',
    'title.terminals': 'Terminallar',
    'title.tickets': 'Biletlər',
    'title.sportsBook': 'Proqram Çapı',
    'title.reports': 'Hesabatlar',
    'title.weeklyBalance': 'Balans Hesabatı',
    'title.creditLimit': 'Aralıq Hesabatı',
    'title.consumptions': 'Ləvazimatlar',
    'title.results': 'Nəticələr',

    /* ================================================================================================================================= */

    /* 07. Betslip */
    'betSlip.emptyMessage': 'Kupon boşdur. Əmsalları Seçməklə Mərc Vərəqinə Əlavə Edin',
    'betSlip.betLine.return': 'Mümkün Uduş',
    'betSlip.betLine.betMax': 'Maks Mərc',
    'betSlip.betLine.closed': 'Bağlıdır',
    'betSlip.select.option.dontAccept': 'Dəyişikliyi Qəbul Etmə',
    'betSlip.select.option.acceptAny': 'İstənilən Dəyişikliyi Qəbul Et',
    'betSlip.select.option.acceptIncrease': 'Artarsa Qəbul Et',
    'betSlip.combinations': 'Kombinasiyalar',
    'betSlip.actions.clearAll': 'Hamısını Sil',
    'betSlip.actions.placeBets': 'Mərc Et',
    'betSlip.actions.bookBet': 'Bron Et',
    'betSlip.summary.numberOfBets': 'Mərclərin Sayı',
    'betSlip.summary.totalStake': 'Yekun Mərc Məbləği',
    'betSlip.summary.totalOdds': 'Yekun Əmsal',
    'betSlip.summary.toWin': 'Mümkün Uduş',
    'betSlip.summary.system': 'Sistem',
    'betSlip.errors.wrongMarketSelectionCombo': 'Ekspress Üçün Yanlış Mərc Seçimi',
    'betSlip.errors.combinationOptions': 'Lütfən, kombinasiya seçimlərinizi nəzərdən keçirin.',
    'betSlip.placeBets.betsInProcess': 'Mərclər İşlənilir…',
    'betSlip.refresh.loadingTitle': 'Yenilənir',
    'betSlip.placeBets.loadingInfoMessage': 'Your bet is loaded into the system',
    'betSlip.refresh.loadingInfoMessage': 'Son Yenilənmələr Yüklənilir...',
    'betSlip.placeBets.successMessage': 'Mərc(lər) Qəbul Edildi!',
    'betSlip.placeBets.ticketNumber': 'Bilet Nömrəsi',
    'betSlip.placeBets.betId': 'Mərc ID',
    'betSlip.placeBets.bonus': 'Bonus Məbləği',
    'betSlip.placeBets.winTax': 'Uduş Vergisi',
    'betSlip.placeBets.potentialPayout': 'Mümkün Uduş',
    'betSlip.placeBets.windowWillClose': 'Pəncərə Bağlanacaq',
    'betSlip.placeBets.acceptOddChanges': 'Əmsal Dəyişikliklərini Qəbul Et',
    'betSlip.actions.retainSelections': 'Seçimləri Saxla',
    'betSlip.actions.clear': 'Təmizlə',
    'betSlip.actions.autoAccept': 'Avto Qəbul',
    'betSlip.actions.manually': 'Əllə',

    /* Misc */
    langDropdownAze: 'Azəri',
    comingSoon: 'Tezliklə',
    allDevicesModalTitle: 'Kassir Cihazları',
    allDevicesModalDescription:
        'Lütfən, daima cihazlarınızın sazlığını saxlayın. Bu, sizin işinizi daha stabil edəcək.',
    allDevicesModalInternetConnection: 'İnternet Bağlantısı',
    allDevicesModalPrinter: 'Printer',
    allDevicesModalScanner: 'Oxuyucu',
    allDevicesModalRefresh: 'Yenilə',
    allDevicesModalDone: 'Oldu',
    lockScreenModalTitle: `Hesabınız hal-hazırda kilidlənib`,
    lockScreenModalDescription: `Uyğun xanaya şifrənizi daxil etməklə hesabınızı aça bilərsiniz.`,
    lockScreenModalEnterPassword: `Şifrənizi Daxil Edin`,
    lockScreenModalSubmitting: `Açılır...`,
    lockScreenModalSubmitButton: `Aç`,
    messagesTabsAll: `Hamısı`,
    messagesTabsRead: `Oxunmuş`,
    messagesTabsNew: `Yeni`,
    messagesTabsSaved: `Saxlanmış`,
    messagesTableColumnsNo: `No`,
    messagesTableColumnsType: `Status`,
    messagesTableColumnsMessageId: `İsmarıc ID`,
    messagesTableColumnsMessage: `İsmarıc`,
    messagesTableColumnsDate: `Tarix/Vaxt`,
    messagesTableRowMore: `Daha Çox`,
    messagesTableRowMessageStatusNew: `Yeni`,
    messagesTableRowMessageStatusSaved: `Saxlanmış`,
    messagesTableRowMessageStatusRead: `Oxunmuş`,
    messagesTableRowMoreModalSaveButton: `Saxla`,
    messagesTableRowMoreModalPrintButton: `Çap Et`,
    messagesTableRowMoreModalMessageId: `İsmarıc ID :`,
    betSlipCombinationsSelection: `Kombinasiyalar`,
    betSlipCombinationsSelectionSelected: `Seçilmiş`,
    betSlipCombinationsBets: `Mərc`,
    othersSidebarTerminals: 'Terminallar',
    othersSidebarTickets: 'Biletlər',
    othersSidebarSportsbookPrint: 'İdman Proqramı',
    othersSidebarReports: 'Hesabat',
    othersSidebarBalanceReport: 'Balans Hesabatı',
    othersSidebarCreditLimitIncreaseReport: 'Aralıq Ödəniş Hesabatı',
    othersSidebarConsumptions: 'Ləvazimatlar',
    terminalsTableColumnsNo: 'No',
    terminalsTableColumnsTerminalName: 'Cihaz Adı',
    terminalsTableColumnsStatus: 'Status',
    terminalsTableColumnsVirtualBalance: 'Cari Balans',
    languagesEnglish: 'English',
    languagesAzerbaijani: 'Azəri',
    eventsFiltersCategoriesAll: 'Bütün Kateqoriyalar',
    eventsFiltersLeaguesAll: 'Bütün Liqalar',
    eventsFiltersLeaguesOutrights: 'Outrights',
    eventsFiltersPeriodsAll: 'Bütün Vaxtlar',
    eventsFiltersPeriodsFirstItem: 'Növbəti 6 saat',
    eventsFiltersPeriodsSecondItem: 'Bu gün',
    eventsFiltersPeriodsThirdItem: 'Sabah',
    eventsFiltersPeriodsFourthItem: 'Bu həftə',
    eventsFiltersPeriodsFifthItem: 'Növbəti 24 saat',
    eventsFiltersOrdersFirstItem: 'Liqa Üzrə Düz',
    eventsFiltersOrdersSecondItem: 'Vaxt Üzrə Düz',
    eventsFiltersOrdersThirdItem: 'MMS Üzrə Düz',
    betSlipTabsSingle: 'Təkli',
    betSlipTabsCombo: 'Ekspress',
    betSlipTabsSystem: 'Sistem',
    betSlipErrorsSingleMbn: 'MMS icazə verilən deyil.',
    betSlipErrorsComboMbn: 'MMS icazə verilən deyil.',
    betSlipErrorsCombination: 'Lütfən, proqnoz seçimlərinizə yenidən baxın.',
    betSlipErrorsEventTypeCombination:
        'Bu tipli mərclərin (kiberidman, normal, uzunmüddətli) birləşdirilməsinə icazə verilmir.',
    betSlipErrorsLiveBetsNotAllowed: 'Bu terminaldan canlı mərc etməyə icazə verilmir.',
    betSlipErrorsMbnCombination: 'MMS icazə verilən deyil.',
    betSlipErrorsMinStake: 'Minimum mərc məbləği %(amount)s AZN',
    betSlipErrorsMaxStake: 'Maksimum mərc məbləği %(amount)s AZN',
    betSlipErrorsMinimumOdd: 'Əmsal minimumdan azdır',
    betSlipErrorsMinimumTotalOdd: 'Yekun əmsal minimumdan azdır',
    betSlipPlacedTicketFoldCount: '%(count)s sütun',
    betSlipPlacedTicketFoldsCount: '%(count)s sütunlar',
    betSlipPlacedTicketBetCount: '%(count)s mərc',
    betSlipPlacedTicketBetsCount: '%(count)s mərclər',
    numericKeyboardSubmit: 'Et',
    changePasswordModalTitle: 'Şifrəni dəyiş',
    changePasswordModalOldPassPlaceholder: 'Köhnə şifrəni daxil edin',
    changePasswordModalNewPassPlaceholder: 'Yeni şifrəni daxil edin',
    changePasswordModalConfirmNewPassPlaceholder: 'Yeni şifrəni təsdiqləyin',
    changePasswordModalChangeButton: 'Şifrəni dəyiş',
    changePasswordModalSuccessMessage: 'Uğurla dəyişdirildi!',
    bancoButton: 'B',
    interfaceLoadingLabel: 'Mərc interfeysi yüklənir',
    headerOpenSession: 'Sessiya açıqdır',
    errorModalRefreshButton: 'Yenilə',
    errorModalLogoutButton: 'Çıxış',
    errorModalCloseButton: 'Bağla',
    logoutModalTitle: 'Çıxış',
    logoutModalContent: 'Çıxmaq istədiyinizdən əminsinizmi?',
    logoutModalYesButton: 'Bəli',
    logoutModalNoButton: 'Xeyr',
    ticketInformationPayWinButton: 'Uduşu ödə',
    ticketInformationPayWinMaxPayAmountError: 'Ödəniləcək məbləğ maksimum ödəniş məbləğindən çoxdur',
    ticketInformationReprintButton: 'Təkrar çap',
    ticketInformationReprintRequestButton: 'Təkrar sorğu',
    ticketInformationReprintRequestSuccess: 'Təkrar çap sorğusu uğurla göndərildi',
    ticketInformationCancelButton: 'Bileti ləğv et',
    ticketInformationCancelLoading: 'Bilet ləğvi',
    ticketStatusAll: 'Hamısı',
    ticketStatusOpen: 'Açıq',
    ticketStatusCancelled: 'Ləğv olunmuş',
    ticketStatusWon: 'Udmuş',
    ticketStatusLost: 'Uduzmuş',
    ticketStatusDraw: 'Draw',
    ticketStatusVoid: 'Geri ödəniş',
    ticketStatusHalfLost: 'Half-Lost',
    ticketStatusHalfWon: 'Half-Won',
    ticketStatusRefunded: 'Geri ödəniş',
    ticketStatusPaid: 'Ödənilmiş',
    ticketInformationBetLineStatusColumn: 'Status',
    ticketInformationEventIdColumn: 'Hadisə kodu',
    ticketInformationBetLineBancoColumn: 'Banko',
    ticketInformationBetLineDateColumn: 'Tarix',
    ticketInformationBetLineEventColumn: 'Hadisə',
    ticketInformationBetLineLeagueColumn: 'Liqa',
    ticketInformationBetLineScoreColumn: 'Cari Hesab',
    ticketInformationBetLineMatchScoreColumn: 'Yekun Hesab',
    ticketInformationBetLineSelectionColumn: 'Seçim',
    ticketInformationBetLineOddsColumn: 'Əmsal',
    ticketInformationBetLineDescriptionColumn: 'Təsvir',
    ticketInformationBetLineStakeColumn: 'Mərc məbləği',
    ticketInformationTitle: 'Bilet məlumatı',
    ticketInformationTerminalNameColumn: 'Mənbə',
    ticketInformationBetId: 'Mərc nömrəsi',
    ticketInformationDateColumn: 'Yaradılma tarixi',
    ticketInformationNumberColumn: 'Barkodu',
    ticketInformationTotalOddsColumn: 'Yekun əmsal',
    ticketInformationTotalCostColumn: 'Bilet dəyəri',
    ticketInformationStakePerBetColumn: 'Hər mərc dəyəri',
    ticketInformationExtraWinColumn: 'Əlavə uduş',
    ticketInformationToWinColumn: 'Potensial uduş',
    ticketInformationWinTaxColumn: 'Uduş vergisi',
    ticketInformationToPayColumn: 'Ödəniləcək məbləğ',
    ticketInformationPaidByColumn: 'Tərəfindən ödənilib',
    ticketInformationPaidDateColumn: 'Ödəniş tarixi',
    ticketInformationPaidColumn: 'Faktiki ödəniş məbləği',
    ticketInformationHeaderBetType: 'Mərc tipi:',
    increaseReportErrorModalGoBackButton: 'Geriyə',
    increaseReportErrorModalDefaultMessage: 'Xəta baş verdi',
    increaseReportSuccessMessage: 'Artım sorğusu uğurla alındı',
    increaseReportIncreaseButton: 'Artır',
    increaseReportSuccessModalOkButton: 'OK',
    filtersStartDatePlaceholder: 'Başlanğıc tarixi',
    filtersEndDatePlaceholder: 'Bitiş tarixi',
    filtersSearchButton: 'Axtar',
    filtersClearButton: 'Təmizlə',
    notAvailableDate: 'Məlumat yoxdur',
    balanceReportSummaryTablePaymentColumn: 'Ödəniş',
    balanceReportSummaryTableLimitIncreaseColumn: 'Balans artımı',
    balanceReportSummaryTableExtraDebtColumn: 'Əlavə debit/kredit',
    balanceReportSummaryTableDebtColumn: 'Debit/Kredit',
    balanceReportSalesColumn: 'Satışlar',
    balanceReportAgentCommissionColumn: 'Komissiya',
    balanceReportTotalSaleColumn: 'Cəmi satışlar',
    balanceReportCancellationColumn: 'Ləğvlər',
    balanceReportTotalCancellationColumn: 'Cəmi ləğvlər',
    balanceReportPaymentColumn: 'Ödənişlər',
    balanceReportTotalPaymentColumn: 'Yekun',
    balanceReportRefundColumn: 'Geri ödənişlər',
    balanceReportTotalRefundColumn: 'Cəmi geri ödənişlər',
    balanceReportRefundCommissionColumn: 'Geri ödəniş komissiyası',
    balanceReportTotalRefundCommissionColumn: 'Yekun',
    balanceReportVoucherSaleColumn: 'Vouçer satışları',
    balanceReportTotalVoucherSaleColumn: 'Cəmi satış',
    balanceReportVoucherRefundColumn: 'Vouçer geri ödənişləri',
    balanceReportTotalVoucherRefundColumn: 'Cəmi geri ödənişlər',
    balanceReportSportsBettingPrematch: 'İdman mərcləri - Prematç',
    balanceReportSportsBettingLive: 'İdman mərcləri - Canlı',
    balanceReportTotalColumn: 'Yekun',
    increaseReportsTableNoColumn: 'No',
    increaseReportsStatusColumn: 'Status',
    increaseReportsAmountColumn: 'Məbləğ',
    increaseReportsRequestDateColumn: 'Sorğu tarixi',
    increaseReportsProcessingDateColumn: 'İcra tarixi',
    increaseReportsStatusAll: 'Hamısı',
    increaseReportsStatusPending: 'Gözləyir',
    increaseReportsStatusSuccessful: 'Uğurlu',
    increaseReportsStatusFail: 'Uğursuz',
    increaseReportsStatusBOIncrease: 'BO Uğurlu',
    increaseReportsStatusBODecrease: 'BO Uğurlu',
    sportsbookPreviewButton: 'Öngörünüş',
    ticketsFiltersOrdersAscending: 'Artan',
    ticketsFiltersOrdersDescending: 'Azalan',
    ticketsTabsOpenBets: 'Açıq Mərclər',
    ticketsTabsBettingHistory: 'Mərc Tarixçəsi',
    ticketsTableNoColumn: 'No',
    ticketsTableStatusColumn: 'Status',
    ticketsTableTerminalColumn: 'Mənbə',
    ticketsTableBetIdColumn: 'Mərc nömrəsi',
    ticketsTableBarcodeColumn: 'Barkod',
    ticketsTableTimeColumn: 'Vaxt',
    ticketsTableTicketCostColumn: 'Bilet dəyəri',
    ticketsTableMaxWinColumn: 'Potensial uduş',
    ticketsTableBetTypeColumn: 'Mərc tipi',
    ticketsTableDetailsButton: 'Detallar',
    resultsFiltersAllCategories: 'Bütün kateqoriyalar',
    resultsFiltersAllLeagues: 'Bütün liqalar',
    resultsFiltersOrdersByTime: 'Vaxt üzrə',
    resultsFiltersOrdersByLeague: 'Liqa üzrə',
    resultsTableEventDateColumn: 'Hadisə tarixi',
    resultsTableEventIdColumn: 'Hadisə kodu',
    resultsTableCategoryColumn: 'Kateqoriya',
    resultsTableLeagueColumn: 'Liqa',
    resultsTableEventColumn: 'Hadisə',
    resultsTableFullTimeColumn: 'Tam vaxt',
    closeButton: 'Bağla',
    generalErrorModalTitle: 'Xəta',
    generalErrorModalDescription: 'Xəta baş verdi.',
    changePasswordSuccessMessage: 'Şifrə uğurla dəyişdirildi.',
    filtersRanges3Hours: '3 saat',
    filtersRanges6Hours: '6 saat',
    filtersRanges12Hours: '12 saat',
    filtersRangesToday: 'Bugün',
    filtersRangesYesterday: 'Dünən',
    filtersRangesThisWeek: 'Bu həftə',
    filtersRangesLastWeek: 'Keçən həftə',
    filtersRangesThisMonth: 'Bu ay',
    filtersRangesLastMonth: 'Keçən ay',
    filtersRangesRangeOption: 'Aralıq',
    ticketsFiltersTypesCashier: 'Kassir',
    increaseReportRequestAmountPlaceholder: 'Məbləğ',
    marketGroupsAllOption: 'Hamısı',
    marketGroupsExpand: 'Hamısını aç',
    marketGroupsCollapse: 'Hamısını bağla',
    marketGroupsMorePlaceholder: 'Daha çox....',
    betSlipErrorsMaxWin: 'Maksimum mərc məbləği xətası',
    betSlipErrorsMaxBetLine: 'Maksimum seçim sayı %(count)s ola bilər',
    searchResultNoOptions: 'Heç nə tapılmadı',
    preMatchProducerIsDown: 'Başlamayan oyunlarla mərc mümkün deyil',
    liveProducerIsDown: 'Canlı oyunlara mərc mümkün deyil',
    popularEvents: 'Populyar oyunlar',
    couponNotFound: 'Kupon tapılmadı',
    betSlipErrorsOddChange: 'Əmsallar dəyişdi',
    print: 'Çap et',
    noMarketsAvailable: 'Aktiv mərc yoxdur',
    internetConnectionOnline: 'Online',
    internetConnectionOffline: 'Offline',
    socketConnectionIsDown: 'Socket connection lost',
    socketConnectionDownHelp: 'Ən son məlumatlari əldə etmək üçün səhifəni yeniləyin.',
    socketConnectionRefreshButton: 'Yenilə',
    newVersionNotificationMessage: 'Yeni versiya mövcuddur',
    newVersionNotificationReload: 'Yenilə',
    couponGeneratedModalTitle: 'Kupon yaradıldı',
    notAuthorized: 'Avtorizə olunmayıb',
    eventTypesRegular: 'Normal',
    eventTypesOutright: 'Uzunmüddətli',
    newMarketIcon: 'YENİ',
};
